import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  // 注文画面用（最小フィールド・ポーリングで頻繁に叩く）
  getKitchenPrinters() {
    return axiosIns.get('/waiter/kitchen_printers')
  },

  // プリンタ設定画面用（死活監視・SDPステータス込み）
  getKitchenPrinterSettings() {
    return axiosIns.get('/waiter/kitchen_printers/settings')
  },

  createKitchenPrinter({
    name, ipAddress, position, sdpEnabled, sdpDeviceId,
  }) {
    const params = snakecaseKeys({
      kitchenPrinter: {
        name, ipAddress, position, sdpEnabled, sdpDeviceId,
      },
    })

    return axiosIns.post('/waiter/kitchen_printers', params)
  },

  updateKitchenPrinter({
    id, name, ipAddress, position, sdpEnabled, sdpDeviceId,
  }) {
    const params = snakecaseKeys({
      kitchenPrinter: {
        name, ipAddress, position, sdpEnabled, sdpDeviceId,
      },
    })

    return axiosIns.put(`/waiter/kitchen_printers/${id}`, params)
  },

  deleteKitchenPrinter(id) {
    return axiosIns.delete(`/waiter/kitchen_printers/${id}`)
  },

  updateRoutings(routings) {
    const params = snakecaseKeys({ routings })

    return axiosIns.put('/waiter/kitchen_printers/update_routings', params)
  },

  // SDP認証情報（sdp_polling_id / sdp_password）をプリンタ単位で再発行する
  issueSdpCredentials(id) {
    return axiosIns.post(`/waiter/kitchen_printers/${id}/issue_sdp_credentials`)
  },
}
